import { LOCALE } from "core/interfaces";

import type { Translation } from "~/common/interfaces/translation.interface";

export const extractTranslation = <T extends Translation>(locale: LOCALE, translations: T[]) => translations.find(translation => translation.locale === locale);
